module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00036.df1e659.png";